// src/components/CategoryProducts.js

import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { db } from "../firebase-config";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { ReactComponent as BackIcon } from "../icons/back.svg";
import "../style/CategoryProducts.css";

const CategoryProducts = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { categoryId } = location.state || {};
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!categoryId) {
      navigate("/mc-admin/panel");
      return;
    }
    fetchProducts();
  }, [categoryId]);

  const fetchProducts = async () => {
    setIsLoading(true);
    try {
      const itemsCollection = collection(db, "products", categoryId, "items");
      const q = query(itemsCollection, orderBy("createdAt", "desc"));
      const querySnapshot = await getDocs(q);

      const productsList = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setProducts(productsList);
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleProductClick = (product) => {
    navigate("/add-product", {
      state: {
        product: product,
        from: "/category-products",
        activeComponent: "categoryProducts",
      },
    });
  };

  const handleBackClick = () => {
    navigate("/mc-admin/panel", {
      state: { activeComponent: "categoryManagement" },
    });
  };

  return (
    <div className="category-products-container">
      <div className="category-products-header">
        <div className="back-button" onClick={handleBackClick}>
          <BackIcon className="back-icon" />
          <span>Back</span>
        </div>
        <h2 className="category-products-title">
          {categoryId} - Products ({products.length})
        </h2>
      </div>

      {isLoading ? (
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Loading products...</p>
        </div>
      ) : products.length === 0 ? (
        <div className="no-products-message">
          <p>No products in this category yet.</p>
        </div>
      ) : (
        <div className="category-01-products-grid">
          {products.map((product) => (
            <div
              key={product.id}
              className="product-card"
              onClick={() => handleProductClick(product)}
            >
              <div className="product-image-container">
                <img
                  src={product.displayImages?.[0] || ""}
                  alt={product.name}
                  className="product-image"
                />
              </div>
              <div className="category-01-product-details">
                <h3 className="product-name">{product.name}</h3>
                <p className="product-price">£{product.price}</p>
                <p className="product-id">{product.productId}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CategoryProducts;
